import { render } from "./The_Footer.vue?vue&type=template&id=1811dfa5"
import script from "./The_Footer.vue?vue&type=script&lang=js"
export * from "./The_Footer.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\abolfazl\\Desktop\\New folder\\vue-tailwind\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__